import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import WhatsAppFloat from '../components/WhatsAppFloat';

const Testimonials = () => {
    useEffect(() => {
        // Force hide spinner immediately
        const spinner = document.getElementById('spinner');
        if (spinner) {
            spinner.classList.remove('show');
            spinner.style.display = 'none';
            spinner.style.opacity = '0';
            spinner.style.visibility = 'hidden';
        }
        if (window.WOW) {
            new window.WOW().init();
        }
        // Note: The global main.js script will likely initialize the owl-carousel,
        // but we may need to manually trigger it if the component mounts after main.js runs.
        if (window.$ && window.$('.testimonial-carousel').length) {
            window.$('.testimonial-carousel').owlCarousel({
                autoplay: true,
                smartSpeed: 1000,
                center: true,
                margin: 24,
                dots: true,
                loop: true,
                nav: false,
                responsive: {
                    0: {
                        items: 1
                    },
                    768: {
                        items: 2
                    },
                    992: {
                        items: 3
                    }
                }
            });
        }
    }, []);

    return (
        <>
            <WhatsAppFloat />
            <Navbar />

            {/* Page Header Start */}
            <div className="container-fluid page-header mb-5 wow fadeIn" data-wow-delay="0.1s">
                <div className="container">
                    <h1 className="display-3 mb-4 animated slideInDown">Testimonial</h1>
                    <nav aria-label="breadcrumb animated slideInDown">
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item"><a href="/">Home</a></li>
                            <li className="breadcrumb-item"><a href="/testimonial">Pages</a></li>
                            <li className="breadcrumb-item active" aria-current="page">Testimonial</li>
                        </ol>
                    </nav>
                </div>
            </div>
            {/* Page Header End */}

            {/* Testimonial Start */}
            <div className="container-xxl py-5">
                <div className="container">
                    <div className="text-center mx-auto wow fadeInUp" data-wow-delay="0.1s" style={{ maxWidth: '600px' }}>
                        <p className="d-inline-block border rounded text-primary fw-semi-bold py-1 px-3">Testimonial</p>
                        <h1 className="display-5 mb-5">What Our Clients Say!</h1>
                    </div>
                    <div className="owl-carousel testimonial-carousel wow fadeInUp" data-wow-delay="0.3s">
                        <div className="testimonial-item">
                            <div className="testimonial-text border rounded p-4 pt-5 mb-5">
                                <div className="btn-square bg-white border rounded-circle">
                                    <i className="fa fa-quote-right fa-2x text-primary"></i>
                                </div>
                                <p>WebBears delivered a fantastic food delivery website, Allaboutfoods, built on the MERN stack. Their expertise and commitment exceeded our expectations.</p>
                            </div>
                            <img className="rounded-circle mb-3" src="img/testimonial-1.jpg" alt="" />
                            <h4>Shehab Khan</h4>
                            <span>Founder, Allaboutfoods</span>
                        </div>
                        <div className="testimonial-item">
                            <div className="testimonial-text border rounded p-4 pt-5 mb-5">
                                <div className="btn-square bg-white border rounded-circle">
                                    <i className="fa fa-quote-right fa-2x text-primary"></i>
                                </div>
                                <p>WebBears created a stellar hardware and services website for us. Their professionalism and attention to detail were exceptional throughout the project.</p>
                            </div>
                            <img className="rounded-circle mb-3" src="img/testimonial-2.jpg" alt="" />
                            <h4>Faizan Ansari</h4>
                            <span>Owner, Hardware and Services</span>
                        </div>
                        <div className="testimonial-item">
                            <div className="testimonial-text border rounded p-4 pt-5 mb-5">
                                <div className="btn-square bg-white border rounded-circle">
                                    <i className="fa fa-quote-right fa-2x text-primary"></i>
                                </div>
                                <p>WebBears did an exceptional job in creating our HVAC products portfolio website. Their dedication and technical prowess are commendable, and we highly recommend them.</p>
                            </div>
                            <img className="rounded-circle mb-3" src="img/testimonial-3.jpg" alt="" />
                            <h4>MSPL</h4>
                            <span>HVAC Products Portfolio</span>
                        </div>
                        <div className="testimonial-item">
                            <div className="testimonial-text border rounded p-4 pt-5 mb-5">
                                <div className="btn-square bg-white border rounded-circle">
                                    <i className="fa fa-quote-right fa-2x text-primary"></i>
                                </div>
                                <p>WebBears did an exceptional job in creating our ecommerce website, BharatiyaBazaar. Their dedication and technical prowess are commendable, and we highly recommend them.</p>
                            </div>
                            <img className="rounded-circle mb-3" src="img/testimonial-4.jpg" alt="" />
                            <h4>Huzaifa Ansari</h4>
                            <span>Owner, BharatiyaBazaar</span>
                        </div>
                        <div className="testimonial-item">
                            <div className="testimonial-text border rounded p-4 pt-5 mb-5">
                                <div className="btn-square bg-white border rounded-circle">
                                    <i className="fa fa-quote-right fa-2x text-primary"></i>
                                </div>
                                <p>WebBears transformed our vision into reality with the stunning home decor website, iGRABiT. Their professionalism and creativity were exceptional throughout the project.</p>
                            </div>
                            <img className="rounded-circle mb-3" src="img/testimonial-5.jpg" alt="" />
                            <h4>Gautham Parkhi</h4>
                            <span>Owner, iGRABiT</span>
                        </div>
                    </div>
                </div>
            </div>
            {/* Testimonial End */}

            <Footer />
        </>
    );
};

export default Testimonials;
